import { generateTimeBasedKey } from '../common';
import { ClientAttributesSelectorModel } from '@/app/core/components/client-attributes';
import {
  ProgramTransformer,
  ProgramTransformerArgs,
} from '@/app/core/components/program-wizard';
import {
  getCurrentFeatureCode,
  getCurrentOktaClientCode,
  OktaUserInfo,
} from '@/app/core/auth';
import {
  AppUserProfile,
  AscendUSAAProgram,
  FeatureCodes,
  FeatureShortCodes,
  getSubCodesForProduct,
} from '@ssar-app/domain';
import { isAuthzAnyValue } from '@ascend/authz';

export const removeOrderNameForCloneProgramFlow: ProgramTransformer = async (
  args: ProgramTransformerArgs,
) => {
  const { program, programWizardMetadata } = args;
  const newProgram = program as AscendUSAAProgram;
  if (
    programWizardMetadata.isClone &&
    newProgram &&
    newProgram.productInput?.productDetails
  ) {
    newProgram.productInput.productDetails.programName = '';
  }
  return Promise.resolve({
    ...args,
    program,
  });
};

export const prepareProgramAndDependentData: ProgramTransformer = async (
  args: ProgramTransformerArgs,
) => {
  const {
    program,
    programWizardMetadata,
    programWizardDependentData,
    messagesStore,
  } = args;
  // prepare the program
  const userProfile = OktaUserInfo.getOktaUserInfo();
  const productName = getCurrentFeatureCode() || '';
  const actualProgram = prepareProgram(
    program as AscendUSAAProgram,
    userProfile,
    programWizardMetadata?.isClone,
    programWizardDependentData.clientAttributesModel,
    FeatureShortCodes[productName],
  );

  return {
    ...args,
    program: {
      ...actualProgram,
    },
    messagesStore: messagesStore,
    programWizardDependentData: {
      ...programWizardDependentData,
    },
  };
};

const prepareProgram = (
  program: AscendUSAAProgram,
  userProfile: AppUserProfile,
  isClone: boolean,
  clientAttributesModel: ClientAttributesSelectorModel,
  productName: string,
): AscendUSAAProgram => {
  const { productInput, packagesInput, ...restProgram } = program || {};
  const { productDetails, ...restProductInput } = productInput || {};
  const {
    submitterName: _submitterName,
    submitterEmail: _submitterEmail,
    clientEmail: _clientEmail,
    clientName: _clientName,
    ...restProductDetails
  } = productDetails || {};

  const newProgram: AscendUSAAProgram = {
    ...restProgram,
    metadata: {
      name: productName,
      version: 'v1',
    },
    productInput: {
      ...restProductInput,
      productDetails: {
        submitterName: userProfile.firstName + ' ' + userProfile.lastName,
        submitterEmail: userProfile.email || '',
        clientName: userProfile.firstName + '' + userProfile.lastName,
        clientEmail: userProfile.email || '',
        ...restProductDetails,
      },
    },
    packagesInput: packagesInput,
  };

  const subCodes = getSubCodesForProduct(FeatureCodes.AscendUSAA, userProfile);

  newProgram.subCode = isAuthzAnyValue(subCodes)
    ? ''
    : subCodes?.[0]?.length > 0
    ? subCodes[0]
    : '';
  newProgram.programKey = generateTimeBasedKey();
  newProgram.loginType = getCurrentOktaClientCode() || '';
  return newProgram;
};
